import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { type WebsiteData } from '@/api/ai/website';
import { Button } from '@/ui_v3';

/**
 * WebsiteUrlModal의 "추가" 버튼.
 *
 * `isExtractable === false` 케이스는 useWebsitePreview에서 alertDialog로
 * 차단되어 websiteData가 set 되지 않으므로, 여기서는 단순히 데이터 유무만
 * 본다.
 */
export const WebsiteConfirmButton = ({
  onConfirm,
  websiteData,
  isLoading = false
}: {
  onConfirm: (websiteData: WebsiteData) => void;
  websiteData: WebsiteData | null;
  isLoading?: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const handleConfirm = useCallback(() => {
    if (!websiteData) {
      return;
    }
    logger.track('quiz_website_url', {
      website_title: websiteData.title,
      website_domain: websiteData.domain,
      content_length: websiteData.contentLength
    });
    onConfirm(websiteData);
  }, [websiteData, onConfirm]);
  return <Button variant="contained" intent="strong" size="md" className="min-w-[120px]" disabled={!websiteData || isLoading} onClick={handleConfirm} data-sentry-element="Button" data-sentry-component="WebsiteConfirmButton" data-sentry-source-file="WebsiteConfirmButton.tsx">
      {t('build:build.website.confirm.button')}
    </Button>;
};